import { StateCreator } from 'zustand';

import { RewardFlowSlice } from './types';

const rewardFlowSlice: StateCreator<RewardFlowSlice> = (set) => ({
  preSelectedEmployeeIds: [],
  preFilledGift: undefined,
  setPreSelectedEmployeeIds: (ids) => set({ preSelectedEmployeeIds: ids }),
  setPreFilledGift: (gift) => set({ preFilledGift: gift }),
  resetRewardFlowData: () => set({ preSelectedEmployeeIds: [], preFilledGift: undefined }),
});

export default rewardFlowSlice;
